export const RAFFLE = {
  brand: "BETMAR",
  title: "GRAN PROYECTO",
  tagline: "Inversión inteligente, futuro asegurado",
  whatsapp: "573214864170",
  whatsappDisplay: "321 486 4170",
  fichaPrice: "50.000",
  currency: "COP",
  earlyDate: "Sábado 26 de Septiembre 2026",
  earlyDateShort: "26 Sep 2026",
  earlyDateNote: "con la de Boyacá",
  earlyPrize: "10.000.000",
  earlyPrizeISO: "2026-09-26T20:00:00-05:00",
  drawDate: "Sábado 31 de Octubre 2026",
  drawDateShort: "31 Oct 2026",
  drawDateNote: "con la de Boyacá",
  drawDateISO: "2026-10-31T20:00:00-05:00",
  location: "Acacías, Meta",
  lote: {
    area: "208",
    frente: "8",
    fondo: "26",
  },
  car: {
    model: "Chevrolet Spark Life 2015",
    color: "Rojo",
    plate: "Único ganador",
  },
};

export const whatsappLink = (
  msg = "Hola BETMAR, quiero adquirir una ficha del Gran Proyecto 🎟️"
) => `https://wa.me/${RAFFLE.whatsapp}?text=${encodeURIComponent(msg)}`;
